import getFirstOrLastBusinessDay from './getFirstOrLastBusinessDay';
export function getNextFirstOrLastBusinessDay(_a) {
    var federalHolidays = _a.federalHolidays, date = _a.date, frequency = _a.frequency;
    var businessDay = getFirstOrLastBusinessDay({
        federalHolidays: federalHolidays,
        date: date,
        frequency: frequency,
    });
    // If the min delivery date is after business day, we need to get the first/last day of next month
    if (date.isAfter(businessDay, 'day')) {
        businessDay = getFirstOrLastBusinessDay({
            federalHolidays: federalHolidays,
            date: date.add(1, 'month'),
            frequency: frequency,
        });
    }
    return businessDay;
}
export default getNextFirstOrLastBusinessDay;
//# sourceMappingURL=getNextFirstOrLastBusinessDay.js.map